import styled from "styled-components";

export const ImageGrid = styled.section`
  padding: 0 80px 80px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  img {
    width: 100%;
    height: 350px;
    object-fit: cover;
    border-radius: 16px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 24px 48px;
    gap: 16px;
  }
`;